import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';

export const StyledLogoBar = styled.div`
  color: ${themeGet('color.colorGrayBlue80')};

  &.maintenance a {
    pointer-events: none;
    color: inherit;
    text-decoration: none;
  }

  .is-size-14 {
    letter-spacing: 2px;
    text-transform: uppercase;
  }
`;

export const StyledLogos = styled.div`
  display: grid;
  grid-template-columns: repeat(3, auto);
  grid-column-gap: ${themeGet('scale.scaleUp06')};
  align-items: center;
  justify-content: center;

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    grid-column-gap: ${themeGet('scale.scaleUp13')};
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    grid-template-columns: repeat(6, auto);
  }
`;

export const StyledLogo = styled.div`
  max-width: 100%;
  display: ${(props) =>
    ['spotify', 'airbnb', 'yelp'].includes(props.logo) ? 'block' : 'none'};

  path {
    fill: #4a6592;
  }

  svg {
    max-width: 100%;
    width: ${(props) => {
      switch (props.logo) {
        case 'spotify':
          return '104px';
        case 'airbnb':
          return '96px';
        case 'yelp':
          return '73px';
        default:
          return '100px';
      }
    }};
  }

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    svg {
      width: ${(props) => {
        switch (props.logo) {
          case 'uber':
            return '97px';
          case 'spotify':
            return '127px';
          case 'airbnb':
            return '117px';
          case 'glassdoor':
            return '150px';
          case 'yelp':
            return '89px';
          case 'instacart':
            return '154px';
          default:
            return '100px';
        }
      }};
    }
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    display: block;
  }
`;
